import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-jige",
  "use": "d2-jige-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"d2-jige\"><path fill=\"#DCDFE6\" d=\"M832 960H64V64h448v320h320v64h64V326.72L551.424 0H0v1024h896V896h-64v64zM576 111.424L795.776 320H576V111.424z m211.392 705.024L900.928 704H448v-64h449.664L790.656 537.856l44.224-46.336L1024 672.064 832.512 861.888l-45.12-45.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol